import { ProductDetails } from "@/@types";
import { useSearchParams } from "next/navigation";
import { BreadcrumbList } from "@/@types/Breadcrumbs";

export default function useProductDetails(product: ProductDetails) {
  const searchParams = useSearchParams();
  const industryParam = searchParams.get("industria");

  if (!product)
    return {
      breadcrumbs: [],
      info: "",
      videos: [],
      documents: [],
      isIndustryView: false,
    };

  const {
    long_description: info,
    contents: { videos, files: documents },
  } = product;
  const breadcrumbMap: BreadcrumbList = []; 
  const isIndustryView = !!industryParam;

  if (isIndustryView) {
    breadcrumbMap.push({ slug: "productos-nuevos", name: "Productos nuevos" });

    if (product.industry.length > 0) {
      const selectedIndustry =
        product.industry.find((industry) => industry.slug === industryParam) ??
        product.industry[0];
      breadcrumbMap.push({
        slug: selectedIndustry.slug,
        name: selectedIndustry.name,
      });
    }

    if (product.family) {
      breadcrumbMap.push({
        slug: product.family.slug,
        name: product.family.name,
      });
    }

    if (product.subfamily) {
      breadcrumbMap.push({
        slug: product.subfamily.slug,
        name: product.subfamily.name,
      });
    }
  } else {
    breadcrumbMap.push({ slug: "productos-por-marca", name: "Productos por marca" });

    if (product.brand) {
      breadcrumbMap.push({ slug: product.brand.slug, name: product.brand.name });
    }

    if (product.industry.length > 0) {
      const selectedIndustry = product.industry[0];
      breadcrumbMap.push({
        slug: selectedIndustry.slug,
        name: selectedIndustry.name,
      });
    }

    if (product.family) {
      breadcrumbMap.push({
        slug: product.family.slug,
        name: product.family.name,
      });
    }

    if (product.subfamily) {
      breadcrumbMap.push({
        slug: product.subfamily.slug,
        name: product.subfamily.name,
      });
    }
  }

  breadcrumbMap.push({ slug: "producto", name: product.slug });

  return {
    breadcrumbMap,
    info,
    videos,
    documents,
    isIndustryView,
  };
}
